import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowLeft, Check, ArrowRight } from 'lucide-react';
import '../styles/ServiceDetail.css';

const ServiceDetail = () => {
  const { serviceId } = useParams();

  const services = {
    'app-development': {
      title: 'Mobile App Development',
      tagline: 'Native & cross-platform apps that users love',
      description: 'We design and build native & cross-platform mobile apps (iOS & Android). From product discovery to app-store launch and ongoing support—we ship secure, maintainable code and measurable product metrics.',
      deliverables: 'MVP in 8–12 weeks',
      pricing: 'Fixed project or Time & Materials',
      features: [
        'iOS development with Swift',
        'Android development with Kotlin',
        'Cross-platform with React Native / Flutter',
        'Backend API development',
        'Push notifications & real-time features',
        'App Store / Play Store optimization',
        'Analytics integration',
        'Ongoing maintenance & updates'
      ],
      process: [
        { phase: 'Discovery', description: 'Product workshops, user research, competitive analysis' },
        { phase: 'Design', description: 'Wireframes, UI/UX design, interactive prototypes' },
        { phase: 'Development', description: 'Agile sprints, continuous integration, weekly demos' },
        { phase: 'Launch', description: 'App store submission, launch strategy, marketing support' },
        { phase: 'Support', description: 'Bug fixes, performance monitoring, feature updates' }
      ],
      caseStudies: ['scholhipw', 'sscbuddy']
    },
    'web-development': {
      title: 'Web Development',
      tagline: 'Scalable web applications that perform',
      description: 'Full-stack web development with modern frameworks. We build fast, secure, and scalable web applications that grow with your business.',
      deliverables: 'Full-stack web apps in 6-10 weeks',
      pricing: 'Fixed project or monthly retainer',
      features: [
        'React, Next.js, Vue.js expertise',
        'Node.js, Python, PHP backend',
        'PostgreSQL, MongoDB, MySQL databases',
        'RESTful & GraphQL APIs',
        'Cloud deployment (AWS, Vercel, DigitalOcean)',
        'Performance optimization',
        'SEO-friendly architecture',
        'Security best practices'
      ],
      process: [
        { phase: 'Planning', description: 'Technical architecture, database design, tech stack selection' },
        { phase: 'Design', description: 'Responsive UI design, component library, brand integration' },
        { phase: 'Development', description: 'Frontend & backend development, API integration' },
        { phase: 'Testing', description: 'Automated testing, performance testing, security audit' },
        { phase: 'Deployment', description: 'CI/CD setup, cloud hosting, monitoring & analytics' }
      ],
      caseStudies: ['BigSoftTech', 'scholarshipwale', 'policymela']
    }
  };

  const service = services[serviceId] || services['app-development'];

  return (
    <div className="service-detail-page" data-testid="service-detail-page">
      <Navbar />
      
      <section className="service-detail-hero">
        <div className="container">
          <Link to="/services" className="back-link" data-testid="back-to-services">
            <ArrowLeft size={20} />
            Back to Services
          </Link>
          <div className="hero-content">
            <h1 className="page-title" data-testid="service-title">{service.title}</h1>
            <p className="page-subtitle" data-testid="service-tagline">{service.tagline}</p>
          </div>
        </div>
      </section>

      <section className="service-detail-content">
        <div className="container">
          <div className="content-layout">
            <div className="main-content">
              <div className="content-section">
                <h2>Overview</h2>
                <p>{service.description}</p>
              </div>

              <div className="content-section">
                <h2>What's Included</h2>
                <div className="features-grid">
                  {service.features.map((feature, i) => (
                    <div className="feature-item" key={i}>
                      <Check size={20} />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="content-section">
                <h2>Our Process</h2>
                <div className="process-timeline">
                  {service.process.map((step, i) => (
                    <div className="process-step" key={i}>
                      <div className="step-number">{i + 1}</div>
                      <div className="step-content">
                        <h3>{step.phase}</h3>
                        <p>{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="sidebar">
              <div className="service-info-card card">
                <h3>Service Details</h3>
                <div className="info-item">
                  <span className="info-label">Deliverables:</span>
                  <span className="info-value">{service.deliverables}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Pricing Model:</span>
                  <span className="info-value">{service.pricing}</span>
                </div>
                <Link to="/contact" className="btn btn-primary" data-testid="request-quote-btn">
                  Request a Quote
                  <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

\    </div>
  );
};

export default ServiceDetail;